<template>
  <span>
    {{ name || translations.actions.GUEST }}
  </span>
</template>

<script lang="ts">
import { merge } from "@pdfking/rfunc"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import user from "../state/user"

export default {
  computed: merge(proxy(user, ["name"]), {
    translations: () => make_translations("actions"),
  }),
  props: [] as const,
}
</script>
